module.exports = __webpack_public_path__ + "assets/map-a09dfe.svg";